import { ClientSpaceConfig, scopedClientKey } from 'ihub/common';
import { CRUDHelperBase } from '../classes/crud-helper-base';
import HttpResponseOptions from '../interface/http-response-options';
import { buildURL, handleResponse, standardPost } from '../classes/http-helper-const';
import Parameter from '../classes/query-parameter';
import { UseQueryOptions } from '@tanstack/react-query';

export class ClientSpaceHttpService extends CRUDHelperBase<ClientSpaceConfig> {
	constructor() {
		super(ClientSpaceConfig.name);
	}

	override getByID(
		Id: string,
		queryParams?: Parameter[]
	): UseQueryOptions<ClientSpaceConfig, Error, ClientSpaceConfig, readonly unknown[]> {
		return super.getByID(Id, queryParams, { [scopedClientKey]: Id });
	}

	override save(
		item: ClientSpaceConfig,
		options?: HttpResponseOptions,
		queryParams?: Parameter[],
		additionalHeaders?: HeadersInit,
		invalidateKeys?: boolean
	): Promise<void> {
		return super.save(item, options, queryParams, { [scopedClientKey]: item.id }, invalidateKeys);
	}

	async createClient(
		item: ClientSpaceConfig,
		options?: HttpResponseOptions,
		queryParams?: Parameter[],
		invalidateKeys = true
	) {
		const url = buildURL(this.objectType, ['Create'], queryParams);
		const response = await standardPost(url, item);
		await handleResponse(response, 'save', this.objectType, options);
		if (invalidateKeys) {
			await super.invalidateKeys();
		}
	}
}
